module.exports = __webpack_public_path__ + "static/media/investor6.a0919350.svg";